import CorporateDataService from "../../../../context/corporates.services";

export const UpdateOptionHomeDelivery = async ({ id, value, enqueueSnackbar, setIsLoading }) => {
    try {
        if(value !== ''){
            if(value.toLowerCase() === 'true'){
                setIsLoading(true);
                await CorporateDataService.updateCorporate('homeDelivery', true, id); 
                enqueueSnackbar(`L'option de livraison à domicile pour les sous-comptes a été activée.`, {
                    variant: 'success',
                    anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                    autoHideDuration: 3000,
                    style: {fontSize: '1.6rem'}
                       
                });
                return true;
            }else{
                setIsLoading(true);
                await CorporateDataService.updateCorporate('homeDelivery', false, id); 
                enqueueSnackbar(`L'option de livraison à domicile pour les sous-comptes a été désactivée.`, {
                    variant: 'success',
                    anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                    autoHideDuration: 3000,
                    style: {fontSize: '1.6rem'}  
                });
                return true;
            }
        }else{
            enqueueSnackbar(`Veuillez séléctionner une option`, {
                variant: 'error',
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                autoHideDuration: 3000,
                style: {fontSize: '1.6rem'}  
            });
        }
    }catch(e) {
        enqueueSnackbar(`${e.message}`, {
            variant: 'error',
            anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
            autoHideDuration: 3000,
            style: {fontSize: '1.6rem'}  
        });
        setIsLoading(false);
        return false;
    }
};